// extracted by mini-css-extract-plugin
module.exports = {"title":"PaymentStep_title__6CYr1","divisionLine":"PaymentStep_divisionLine__hGFpg","img":"PaymentStep_img__Omv5W"};